module.exports = require("yaml-js");


//////////////////
// WEBPACK FOOTER
// external "yaml-js"
// module id = 605
// module chunks = 0